import actions from "./actions";
import dayjs from "dayjs";

export default {
  actions,
  state: {
    startedAt: null,
    endedAt: null,
    keyWord: null,
    page: null,
    perPage: null,
    totalListItems: null,
    newlyAddedNewsAll: {},
    newlyAddedSurveyAll: {}
  },
  mutations: {
    initPagination(state) {
      state.startedAt = dayjs()
        .subtract(1, "month")
        .format("YYYY-MM-DD");
      state.endedAt = dayjs().format("YYYY-MM-DD");
      state.keyWord = "";
      state.page = 1;
      state.perPage = 50;
      state.totalListItems = 1;
    },
    startedAt(state, payload) {
      state.startedAt = payload;
    },
    endedAt(state, payload) {
      state.endedAt = payload;
    },
    keyWord(state, payload) {
      state.keyWord = payload;
    },
    page(state, payload) {
      state.page = payload;
    },
    perPage(state, payload) {
      state.perPage = payload;
    },
    totalListItems(state, payload) {
      state.totalListItems = payload;
    },
    newlyAddedNewsAll(state, payload) {
      state.newlyAddedNewsAll = payload;
    },
    newlyAddedSurveyAll(state, payload) {
      state.newlyAddedSurveyAll = payload;
    }
  },
  getters: {
    startedAt({ startedAt }) {
      return startedAt;
    },
    endedAt({ endedAt }) {
      return endedAt;
    },
    keyWord({ keyWord }) {
      return keyWord;
    },
    page({ page }) {
      return page;
    },
    perPage({ perPage }) {
      return perPage;
    },
    totalListItems({ totalListItems }) {
      return totalListItems;
    },
    newlyAddedNewsAllList({ newlyAddedNewsAll }) {
      return newlyAddedNewsAll.data;
    },
    newlyAddedSurveyAllList({ newlyAddedSurveyAll }) {
      return newlyAddedSurveyAll.data;
    }
  }
};
